import type { SupabaseClient } from '../supabase/client';
import type { Store } from '../types/store';

export async function getAdminStore(client: SupabaseClient, storeId: string): Promise<Store> {
  const { data, error } = await client.rpc('get_admin_store', {
    target_store_id: storeId,
  } as never);

  if (error) throw error;
  if (!data) throw new Error('get_admin_store: empty result');
  return data as unknown as Store;
}
